
export default function ServiceAreas() {
  const areas = [
    { name: 'Muscat', service: 'Cleaning Services Muscat' },
    { name: 'Seeb', service: 'Cleaning Company Seeb' },
    { name: 'Al Khuwair', service: 'House Cleaning Al Khuwair' },
    { name: 'Azaiba', service: 'Office Cleaning Azaiba' },
    { name: 'Mabela', service: 'Deep Cleaning Mabela' },
    { name: 'Mawaleh', service: 'Villa Cleaning Mawaleh' },
    { name: 'Barka', service: 'Cleaning Services Barka' },
    { name: 'Sohar', service: 'Cleaning Company Sohar' },
    { name: 'Rustaq', service: 'Professional Cleaning Rustaq' },
    { name: 'Nakhal', service: 'Residential Cleaning Nakhal' },
    { name: 'Quriyat', service: 'Commercial Cleaning Quriyat' },
    { name: 'Nizwa', service: 'Cleaning Services Nizwa' },
    { name: 'Al Hail', service: 'House Cleaning Al Hail' },
    { name: 'Salalah', service: 'Cleaning Company Salalah' },
    { name: 'Al Amarat', service: 'Office Cleaning Al Amarat' },
    { name: 'Ruwi', service: 'Deep Cleaning Ruwi' }
  ];

  return (
    <div id="areas" className="py-20 bg-gradient-to-b from-yellow-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-yellow-600 font-semibold text-sm uppercase tracking-wider">Service Coverage Areas</span>
          <h2 className="text-4xl font-bold text-gray-900 mt-3 mb-4">
            <strong>Cleaning Services Oman</strong> – Serving <span className="text-yellow-500">All Major Cities</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Professional <strong>cleaning company Oman</strong> providing <strong>house cleaning</strong>, <strong>office cleaning</strong>, and <strong>deep cleaning services</strong> throughout Muscat, Seeb, Barka, Mabela, Al Hail, Sohar, Salalah &amp; all regions
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-12">
          {areas.map((area, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 border border-yellow-100 text-center group"
            >
              <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-yellow-500 transition-colors duration-300">
                <i className="ri-map-pin-line text-2xl text-yellow-600 group-hover:text-black transition-colors duration-300"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{area.name}</h3>
              <p className="text-sm text-gray-600">{area.service}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                <strong>Complete Cleaning Services Coverage</strong> Across <span className="text-yellow-500">All Oman</span>
              </h3>
              
              <h4 className="text-xl font-semibold text-gray-800 mb-4">
                Professional Cleaning Company Serving Residential &amp; Commercial Properties
              </h4>
              
              <p className="text-gray-600 mb-4 leading-relaxed">
                <strong>Cleaning Bees</strong> proudly provides <strong>professional cleaning services Oman</strong> across all major cities and regions. Whether you need <strong>house cleaning in Muscat</strong>, <strong>office cleaning in Seeb</strong>, <strong>villa cleaning in Barka</strong>, or <strong>commercial cleaning in Sohar</strong>, our expert team delivers exceptional service to your location.
              </p>
              
              <h5 className="text-lg font-semibold text-gray-800 mb-3">
                Local Cleaning Experts Understanding Oman's Unique Needs
              </h5>
              
              <p className="text-gray-600 mb-4 leading-relaxed">
                We understand the unique <strong>cleaning needs</strong> of different areas and properties across Oman. From coastal regions to inland cities, our experienced <strong>cleaning company</strong> provides consistent, high-quality <strong>residential cleaning Oman</strong> and <strong>commercial cleaning services</strong> tailored to local requirements in Muscat, Seeb, Barka, Mabela, Al Hail, Sohar, and Salalah.
              </p>
              
              <h6 className="text-lg font-semibold text-gray-800 mb-3">
                Quick Response &amp; Reliable Scheduling Across Oman
              </h6>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                Our extensive service network ensures quick response times and reliable scheduling for <strong>cleaning services in Oman</strong>, no matter your location. We're committed to making <strong>professional cleaning services</strong> accessible to everyone across Muscat, Seeb, Barka, Sohar, Salalah, and all Oman regions. Find a trusted <strong>cleaning company near me in Oman</strong> – that's us!
              </p>
              <a
                href={`https://wa.me/+96871989006?text=${encodeURIComponent('Hello Cleaning Bees, I would like to know if you serve my area in Oman.')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 bg-yellow-500 text-black px-6 py-3 rounded-lg hover:bg-yellow-600 transition-colors whitespace-nowrap cursor-pointer font-semibold"
              >
                <i className="ri-map-pin-user-line text-xl"></i>
                <span>Check Your Area</span>
              </a>
            </div>
            
            <div className="relative">
              <div className="w-full h-96 rounded-xl overflow-hidden shadow-lg">
                <img 
                  src="https://public.readdy.ai/ai/img_res/738d841a557f8847ff2bbee9d065d1a1.jpg" 
                  alt="Cleaning Bees service areas map - cleaning company Oman covering Muscat, Seeb, Barka, Sohar, Salalah"
                  title="Professional Cleaning Services Coverage Across All Oman Cities"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
